import React from 'react';
import Module from 'Components/Core/Module';
import Form from 'Components/Core/Form/Form';
import FormElement from 'Components/Core/Form/FormElement';
import './ForumOptions.css';

export default function ForumOptions(props) {

	const x = props.x;
	const wafId = props.id;

	x.waf.init(wafId, {
		"onAfterRead": onAfterRead
	});

	x.wam.init(props.id, {
		"onClose": () => {
			x.waf.destroy(wafId);
		}
	});

	function onAfterRead(data) {
		x.waf.set(wafId, 'title', data.content.title, true);
		x.waf.set(wafId, 'registrationcode', data.content.registrationcode, true);
		x.waf.set(wafId, 'develop', data.content.develop, true);
		x.waf.set(wafId, 'answerasquote', data.content.answerasquote, true);
		x.waf.set(wafId, 'chatmode', data.content.chatmode, true);
	}

	function generateRegistrationCode() {
		x.waf.set(wafId, 'registrationcode', crypto.randomUUID());
	}

	return (
		<Module id={props.id} x={x} title={props.title} display={props.display} displayTitle="d-block" closeButton="1">
			<div className="forum-options">
				<Form x={x}
					wafId={wafId}
					module="System"
					readTask="GetProjectSettings"
					sendTask="SaveProjectSettings"
					focusElement="title"
					classes="forum-options-form"
				>
					<FormElement x={x} wafId={wafId} id="title" title="Titel" mandatory={true} />
					<FormElement x={x} wafId={wafId} id="registrationcode" title="Registrierungs-Code" mandatory={true} classes="reg-code-input">
						<button type="button" className="btn btn-sm" onClick={generateRegistrationCode}>
							<i className="bi bi-arrow-clockwise"></i>Neu erzeugen
						</button>
					</FormElement>
					<FormElement type="checkbox" x={x} wafId={wafId} id="develop" title="Develop-Modus" />
					<FormElement type="checkbox" x={x} wafId={wafId} id="answerasquote" title="Antworten als Zitat in neuem Thread" />
					<FormElement type="checkbox" x={x} wafId={wafId} id="chatmode" title="Chat-Modus" />
				</Form>
			</div>
		</Module>
	)

};
